import { Component } from '@angular/core';
import { ProjectNotesComponent } from '../project.notes.component';

@Component({
  selector: 'app-project-notes-mobile',
  templateUrl: './project-notes-mobile.component.html',
  styleUrls: ['./project-notes-mobile.component.scss']
})
export class ProjectNotesMobileComponent extends ProjectNotesComponent  {
}
